import HttpService from "./htttp.service";

class ProductsService {
  // ProductsEndpoint = process.env.API_URL;

  getProducts = async () => {
    const getProducts = "dash/products";
    return await HttpService.get(getProducts);
  };

  getProductSingle = async (id) => {
    const getProductSingle = `dash/products/${id}`;
    return await HttpService.get(getProductSingle);
  };

  getProductsStats = async () => {
    const getProductsStats = "dash/products/stats";
    return await HttpService.get(getProductsStats);
  };

  getProductsPerService = async (id) => {
    const getProductsPerService = `dash/products/service/${id}`;
    return await HttpService.get(getProductsPerService);
  };

  createProducts = async (payload) => {
    const createProducts = "dash/products/new";
    return await HttpService.post(createProducts, payload);
  };

  editProducts = async (id, payload) => {
    const editProducts = `dash/products/${id}`;
    return await HttpService.put(editProducts, payload);
  };
}

export default new ProductsService();
